export const fmtDate = (iso) => {
  if (!iso) return "—";
  if (typeof iso === "string" && iso.includes("T")) {
    const d = new Date(iso);
    if (!Number.isNaN(d.getTime())) return d.toLocaleDateString("pt-BR");
  }
  const parts = String(iso).split("-");
  if (parts.length >= 3) {
    const [y, m, d] = parts;
    return `${d}/${m}/${y}`;
  }
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? String(iso) : d.toLocaleDateString("pt-BR");
};

export const fmtDateTime = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (!Number.isNaN(d.getTime())) {
    return d.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }
  const raw = String(value);
  return raw.replace("T", " ").replace(/\.\d+Z?$/, "");
};

export const fmtMoney = (n) => Number(n || 0).toLocaleString("pt-BR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const fmtMeasure = (value, digits = 3) => Number(value || 0).toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: digits });
export const today = () => new Date().toISOString().split("T")[0];
export const buildOrderTitle = (cc, date) => `${cc} – ${fmtDate(date)}`;
export const nextId = (arr) => (arr.length ? Math.max(...arr.map((x) => Number(x.id) || 0)) + 1 : 1);
export const createClientId = (prefix = "id") => `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

export function compressImage(file, maxSide = 800, quality = 0.75) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
        const w = Math.max(1, Math.round(img.width * scale));
        const h = Math.max(1, Math.round(img.height * scale));
        const c = document.createElement("canvas");
        c.width = w;
        c.height = h;
        const ctx = c.getContext("2d");
        if (ctx) ctx.drawImage(img, 0, 0, w, h);
        resolve(c.toDataURL("image/jpeg", quality));
      };
      img.onerror = () => resolve(typeof e?.target?.result === "string" ? e.target.result : "");
      img.src = e.target.result;
    };
    reader.onerror = () => resolve("");
    reader.readAsDataURL(file);
  });
}


export const fmtDateTimeUtcOffset = (value, utcOffsetHours = null) => {
  if (!value) return "—";
  const raw = String(value || "").trim();
  const normalized = /^\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2})?)?$/.test(raw) && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(raw)
    ? raw.replace(" ", "T") + "Z"
    : raw;
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return raw.replace("T", " ").replace(/\.\d+Z?$/, "");
  const effectiveUtcOffset = utcOffsetHours == null || utcOffsetHours === "" || !Number.isFinite(Number(utcOffsetHours))
    ? -3
    : Number(utcOffsetHours);
  const shifted = new Date(date.getTime() + effectiveUtcOffset * 3600000);
  return shifted.toLocaleString("pt-BR", { day:"2-digit", month:"2-digit", year:"numeric", hour:"2-digit", minute:"2-digit", timeZone: "UTC" });
};
